export var canUseDOM = /*#__PURE__*/ function() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}();
export var canUseEventListeners = /*#__PURE__*/ function() {
    return canUseDOM && !!window.addEventListener;
}();
export function onDOMLoaded(callback) {
    if (document.readyState !== "loading") {
        callback();
    } else {
        document.addEventListener("DOMContentLoaded", callback);
    }
}

//# sourceMappingURL=dom.js.map